module.exports = __webpack_public_path__ + "img/zaycev.c2ef06d0.png";